module.exports = __webpack_public_path__ + "img/yujing3.eba18757.png";